module.exports = __webpack_public_path__ + "static/media/TheCollectiveBecome-Medium.60936077.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TheCollectiveBecome-Medium.woff2
// module id = 733
// module chunks = 0